import React, { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CardSingleTop from "../card-single-top";
import { selectCars } from "../../../redux/car/car-slice";
import WelcomeDashboard from "../../../pages/welcome-dashboard/WelcomeDashboard";
import styles from "./FillCarsSlider.module.css";

const FillCarsSlider = () => {
    const cars = useSelector(selectCars);

    const scrollRef = useRef(null);

    // state برای drag
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollStart = useRef(0);
    const hasMoved = useRef(false);

    // جلوگیری از کلیک بعد از drag
    const [dragging, setDragging] = useState(false);

    /* ============================
       Mouse drag handlers
    ============================ */
    const handleMouseDown = (e) => {
        const el = scrollRef.current;
        if (!el) return;

        isDragging.current = true;
        hasMoved.current = false;

        startX.current = e.pageX;
        scrollStart.current = el.scrollLeft;

        // فقط روی موس چپ
        if (e.button !== 0) return;
    };

    const handleMouseMove = (e) => {
        if (!isDragging.current) return;
        const el = scrollRef.current;
        if (!el) return;

        const dx = e.pageX - startX.current;

        // اگه بیشتر از 4px حرکت کرد، یعنی drag واقعی
        if (Math.abs(dx) > 4) {
            hasMoved.current = true;
            setDragging(true);
        }

        // چون RTL هستیم، جهت اسکرول معکوسه
        el.scrollLeft = scrollStart.current - dx;
    };

    const handleMouseUp = () => {
        isDragging.current = false;
        setDragging(false);
    };

    const handleMouseLeave = () => {
        isDragging.current = false;
        setDragging(false);
    };

    /* ============================
       جلوگیری از کلیک بعد از drag
    ============================ */
    const handleClickCapture = (e) => {
        if (hasMoved.current) {
            e.preventDefault();
            e.stopPropagation();
            hasMoved.current = false;
        }
    };

    /* ============================
       پاک کردن event listeners
       در صورت unmount
    ============================ */
    useEffect(() => {
        const handleUp = () => {
            isDragging.current = false;
            setDragging(false);
        };

        window.addEventListener("mouseup", handleUp);
        return () => window.removeEventListener("mouseup", handleUp);
    }, []);

    /* ============================
       حالت خالی
    ============================ */
    if (!cars || cars.length === 0) {
        return (
            <div className={styles.emptyWrapper}>
                <WelcomeDashboard />
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <div
                ref={scrollRef}
                className={`${styles.scrollArea} ${
                    dragging ? styles.dragging : ""
                }`}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
                onClickCapture={handleClickCapture}
            >
                {cars.map((car) => (
                    <div key={car.id} className={styles.slideItem}>
                        <CardSingleTop car={car} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FillCarsSlider;